// Add-to-cart island: posts the product form to the cart API, updates the header count and
// shows a toast. Without JavaScript the same form posts to /cart and the server redirects.

const API = "/api/method/softech_commerce.api.cart.";

export async function cartCall(method, data) {
	const csrf = document.querySelector('meta[name="csrf-token"]');
	const response = await fetch(API + method, {
		method: "POST",
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
			...(csrf ? { "X-Frappe-CSRF-Token": csrf.content } : {}),
		},
		body: JSON.stringify(data),
	});
	const body = await response.json().catch(() => ({}));
	if (!response.ok) throw new Error(serverMessage(body));
	return body.message;
}

function serverMessage(body) {
	try {
		const messages = JSON.parse(body._server_messages || "[]");
		return JSON.parse(messages[messages.length - 1]).message;
	} catch (e) {
		return "";
	}
}

export function setCount(count) {
	document.querySelectorAll("[data-cart-count]").forEach((el) => (el.textContent = count));
}

export function toast(text) {
	let el = document.querySelector(".toast");
	if (!el) {
		el = document.createElement("div");
		el.className = "toast";
		el.setAttribute("role", "status");
		document.body.appendChild(el);
	}
	el.textContent = text;
	el.hidden = false;
	clearTimeout(el._timer);
	el._timer = setTimeout(() => (el.hidden = true), 3500);
}

export function initAddToCart(form) {
	form.addEventListener("submit", async (event) => {
		const code = form.querySelector("[data-item-code]").value;
		if (!code) return; // let the server explain (no-JS path)
		event.preventDefault();
		const button = form.querySelector("[data-add-button]");
		// busy, not disabled: a disabled button loses the keyboard focus (a theme's mini cart
		// returns it to the button when it closes)
		if (button.getAttribute("aria-disabled") === "true") return;
		button.setAttribute("aria-disabled", "true");
		try {
			const result = await cartCall("add", {
				item_code: code,
				qty: form.qty.value || 1,
				lang: document.documentElement.lang,
			});
			setCount(result.count);
			toast(result.warning || form.dataset.added);
			// themes may react, e.g. Grocery's mini cart (M7-02)
			document.dispatchEvent(new CustomEvent("store:cart-added", { detail: result }));
		} catch (e) {
			toast(e.message || form.dataset.failed);
		} finally {
			button.removeAttribute("aria-disabled");
		}
	});
}
